"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var date_fns_1 = require("date-fns");
var InfoTooltip_1 = __importDefault(require("atomicComponents/organisms/Tooltip/InfoTooltip"));
var Text_1 = __importDefault(require("shared/components/Text"));
var PresendTooltip = function (_a) {
    var _b;
    var date = _a.date;
    var theme = (0, material_1.useTheme)();
    var daysLeft = (0, date_fns_1.differenceInDays)(new Date(date), new Date((0, end2end_1.getISODate)(new Date())));
    return ((0, jsx_runtime_1.jsx)(InfoTooltip_1.default, { placement: "top", iconProps: { size: 'xs', color: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.contrastText }, maxWidth: 300, title: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2, fontWeight: 600, lineHeight: "21px" }, { children: ["Your billing date is in ", daysLeft, " days"] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ component: "ul", m: 0 }, { children: [(0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ component: "li", level: 2, fontSize: 12, lineHeight: "15px" }, { children: ["If you tick this box customers receive the agreement immediately, but payment will be collected on the invoice date ", ' ', date && "(".concat(date, ").")] })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ component: "li", level: 2, fontSize: 12, lineHeight: "15px" }, { children: "Otherwise, they receive the agreement on the invoice date and payment is collected once they set up a payment method." }))] }))] })) }));
};
exports.default = PresendTooltip;
